import { m } from 'framer-motion';
import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// layouts
import CompactLayout from 'src/layouts/compact';
// assets
import { SeverErrorIllustration } from 'src/assets/illustrations';
// components
import { RouterLink } from 'src/routes/components';
import { MotionContainer, varBounce } from 'src/components/animate';
import { useEffect } from 'react';
//
import {
    signOut
  } from 'firebase/auth';
import { paths } from 'src/routes/paths';
import axios from 'src/utils/axios';
import useFirebaseApp from 'src/hooks/use-firebase-app';
// ----------------------------------------------------------------------

export default function ErrorView({ error }) {
    const { firebaseAuth } = useFirebaseApp();

    useEffect(() => {
        if(error && error.status === 401 && firebaseAuth){
            alert('Session expired');
            
            sessionStorage.removeItem('accessToken');
            delete axios.defaults.headers.common.Authorization;
            
            signOut(firebaseAuth);
        
            window.location.href = paths.auth.jwt.login;
        }
    }, [error, firebaseAuth]);

    return (
        <CompactLayout>
            <MotionContainer>
                <m.div variants={varBounce().in}>
                    <Typography variant="h3" sx={{ mb: 2 }}>
                        {
                            error?.data?.error?.message 
                            ?
                            error?.status === 401 ? "Session expired" : error?.data?.error?.message
                            :
                            "Something went wrong"
                        }
                    </Typography>
                </m.div>

                <m.div variants={varBounce().in}>
                    <Typography sx={{ color: 'text.secondary' }}>
                        {
                            error?.status === 401
                            ?
                            'Please login again'
                            :
                            'Please try again later or contact the team'
                        }
                    </Typography>
                </m.div>

                <m.div variants={varBounce().in}>
                    <SeverErrorIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
                </m.div>
            </MotionContainer>
        </CompactLayout>
    );
}

ErrorView.propTypes = {
    error: PropTypes.any,
    showTryAgain: PropTypes.bool
};